import React, { Component } from 'react'
class InfoItemsList extends Component {
    render() {
        let infoItems = this.props.infoItems
        let categories = Object.keys(infoItems)
        return <div style={{height:"calc(100% - 48px"}}><ul id="preview-info-items-list" className={`max-width ${this.props.displayingInfoItemsList ? 'slide-up' : 'slide-down'}`}>
            {categories.length > 0 ? categories.map(category => {
                return <li id="preview-info-item-list-item" key={category} className="flex-column">
                        <label style={{fontWeight: "bold"}}>{category}</label>
                        <ul className="flex-column-center">
                            {infoItems[category].map(item => {
                                return <li key="item" style={{ margin: "1em", padding: '.2em', listStyle: "disc"}}>{item}</li>
                            })}
                        </ul>
                    </li>
            }) : <li id="no-list-item" key={"No Alerts"} className="flex-column">
                    <label style={{ margin: ".625em" }}>No Alerts</label>
                </li>}
            </ul></div>
    }
}

export default InfoItemsList